import React from 'react';
import ReactDOM from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { ModalsProvider } from '@mantine/modals';
import { PostHogProvider } from '@posthog/react';
import posthog from 'posthog-js';
import { getConsent } from './components/CookieConsent';

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';

import './index.css';
import './i18n';
import App from './App';
import theme from './theme';

// Na telefonach nie pokazujemy ankiet PostHog - popup ankiety na małym ekranie
// zasłania treść i psuje UX. Trackowanie zdarzeń działa normalnie.
function isMobileViewport() {
  return typeof window !== 'undefined' && window.matchMedia
    && window.matchMedia('(max-width: 768px)').matches;
}

function initPostHog() {
  if (getConsent() === 'accepted') {
    posthog.init('phc_wUSYn3ehT8L9rNKdXhXJARnwdQZoGi9nbDbptRMoQrNu', {
      api_host: 'https://eu.i.posthog.com',
      capture_pageview: true,
      capture_pageleave: true,
      disable_surveys: isMobileViewport(),
    });
  }
}

initPostHog();
window.addEventListener('cookie-consent-changed', initPostHog);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <MantineProvider theme={theme} defaultColorScheme="light">
        <ModalsProvider>
          <Notifications position="top-right" />
          <App />
        </ModalsProvider>
      </MantineProvider>
    </PostHogProvider>
  </React.StrictMode>
);
